import React from 'react';
import LyriaPay from '@weezevent/lyriapay';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import './payment.css';

const format_price = (amount, currency) => {
    return new Intl.NumberFormat(i18n.language.replace("_", "-"), { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(amount);
}

function RecapRow({row}){
    const price_ttc = format_price(row.price_ttc ? row.price_ttc / 100 : null, row.currency);
    return (
        <div className='payment-recap'>
            <span>{row.name}</span>
            <span>{price_ttc}</span>
        </div>
    )
}

function RecapPayment({transaction_data}){
    const { t } = useTranslation();
    const price = format_price(transaction_data.amount, transaction_data.currency);

    return(
        <div>
            <div className='payment-title'>{t('widget.payment.title')}</div>
            {transaction_data.transaction_rows.map(row=><RecapRow row={row}/>)}
			<div className='payment-total'>
				<span>{t('widget.payment.total')}</span>
				<span>{price}</span>
			</div>
        </div>
    )
}

export default function StepPayment({ config, onSubmit }) {
	const { payment: {lyria_token: { url, token }, transaction_data}} = config;

	return (
		<div className='payment-container'>
			<RecapPayment transaction_data={transaction_data}/>
			<LyriaPay
				lyriaUrl={url}
				token={token}
				onPaymentResult={response => {
					if(response.success) {
						onSubmit();
					}
				}}
				lang={i18n.language}
				loader={
					<div id="wave-loader">
						<span className="dot"/>
						<span className="dot"/>
						<span className="dot"/>
					</div>
				}
			/>
		</div>
	)
}
